import styled from "styled-components/macro";

import { motion } from "framer-motion";

import { useCloseModal } from "UI/FnrModal";

export default function CloseButton({
  setShouldClearDisplayMessages,
  setInputErrors,
}) {
  const closeModal = useCloseModal();
  const handleClose = () => {
    "closing modal, setting shouldClear to true and inputErrors to []";
    closeModal();
    setInputErrors([]);
    setShouldClearDisplayMessages(true);
  };
  const closeModalDelay = () => setTimeout(handleClose, 125);
  return (
    <Wrapper
      onClick={closeModalDelay}
      className="fas fa-times-circle"
      whileHover={{ opacity: 1, scale: 1.1 }}
      whileTap={{ opacity: 1, scale: 0.95 }}
    ></Wrapper>
  );
}
const Wrapper = styled(motion.div)`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 7px;
  margin-top: 7px;
  opacity: 0.6;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
`;
